import ApiClient from '@/libs/http-client'

const AttendanceService = {
    endpoints(route, param) {
        const url = {
            getAllReports: `/api/attendances/reports/${param}`,
            startWorkingDay: '/api/work/start',
            endWorkingDay: '/api/work/end',
            startPause: '/api/work/pause/start',
            endPause: '/api/work/pause/stop',
            getCurrentInfo: '/api/work/today',
            getCurrentInfoAll: '/api/work/review',
        }
        return route[url]
    },
    get(url, param) {
        return ApiClient.get(this.endpoints(url, param));
    },
    put(url, params, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    startWorkingDay(config) {
        return ApiClient.post('/api/work/start', config)
    },
    endWorkingDay(config) {
        return ApiClient.post('/api/work/end', config)
    },
    startPause(config) {
        return ApiClient.post('/api/work/pause/start', config)
    },
    endPause(config) {
        return ApiClient.post('/api/work/pause/stop', config)
    },
    getCurrentInfoAll(config) {
      return ApiClient.get('/api/work/review', config)
    },
    getCurrentInfo(config) {
        return ApiClient.get('/api/work/today', config)
    },
    setReports(data, config) {
        return ApiClient.post('/api/work/reports', data, config)
    },
    editReports(data, config) {
      const { task_id, report, seconds, date, overtime } = data
      return ApiClient.put(`/api/work/reports/${data.attendance_id}`, {
        task_id,
        report,
        seconds,
        date,
        overtime
      }, config)
    },
    
    resumeWorkingDay(config) {
        return ApiClient.post('/api/work/resume', config)
    },
    getWorkingUsers(config) {
        return ApiClient.get('/api/users/online', config)
    },
    getUserReports(payload, config) {
        // return ApiClient.get(`/api/users/${payload.id}/workdays?from=${payload.from}&to=${payload.to}`, config)
        return ApiClient.get(`/api/users/${payload.id}/workdays?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}`, config)
    },

    getGeneralReports(payload, config) {
        return ApiClient.get(`/api/work?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}`, config)
    },

    getWastedTime(payload, config) {
        return ApiClient.get(`/api/work/time?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}&user_id=${payload.user_id}`, config)
    },

    getTaskProgress(payload, config) {
        return ApiClient.get(`/api/work/progress?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}&user_id=${payload.user_id}`, config)
    },

    getTaskReports(payload, config) {
        return ApiClient.get(`/api/work/days?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}&user_id=${payload.user_id}`, config)
    },

    getExcel(payload, config) {
        return ApiClient.get(`/api/work/days/export?from=${payload.from}&to=${payload.to}&project_id=${payload.project_id}&user_id=${payload.user_id}`, config)
    },

    getTaskDetails(payload, config) {
        return ApiClient.get(`/api/vacations/general?&user_id=${payload.user_id}&start=${payload.from}&end=${payload.to}&type=${payload.type}&active=${payload.status}&without_pay=${payload.without_pay}`, config)
    }
}

export default AttendanceService
